import React, { useState } from 'react';
import { useField } from 'formik';
import bem from 'utils/bem';
import FormError from 'forms/fields/FormError';

import './index.sass'

const { cnBlock } = bem('form-field', 'form-text');

export const MaxNumberTextField = ({ className, name, max, ...props }) => {

    const [ field, meta ] = useField({ name, type: 'text' });

    const [ value, setValue ] = useState('')

    const onChange = (e) => {
        const input = e.currentTarget.value;
        if (isNaN(input)) { return; }
        if (input === '') {
            setValue('');
            return;
        }
        const validInput = Math.min(Math.max(0, input), max);
        setValue(`${validInput}`);
    }

    return <div className={ cnBlock(className, { 'invalid': meta.error && meta.touched }) }>
        <input
            { ...field }
            { ...props }
            inputMode='numeric'
            pattern='[0-9]*'
            placeholder='0'
            value={value}
            onChange={onChange}
        />
        { meta.error && meta.touched && <FormError>{ meta.error }</FormError> }
    </div>

}

